//@flow
import * as React from 'react'
import type { LetoQualityReviewContainer$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const LetoQualityReviewContainer=(props:LetoQualityReviewContainer$Props)=>{
    const leto = props.leto
    let isVisible = false

    if (leto.reviewQuestions && leto.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'letoQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'letoPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(leto.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default LetoQualityReviewContainer


// WEBPACK FOOTER //
// ./src/views/ProjectLeto/LetoQualityReviewContainer.js